<template>
  <div>
    <div class="row-header d-flex align-items-center">
      <div
        v-if="rows.length > 0 || $slots.content"
        v-on:click="toggle"
        class="d-flex toggle-switch mr-3"
      >
        <Icon icon="angle-left" color="alpha" :rotate="getExpandCollapseIconRotation()" />
      </div>
      <div class="flex-fill">
        <slot name="header">
          <div class="d-flex justify-content-center align-items-center">
            <div class="flex-fill">
              <slot name="header:title">{{ headerTitle }}</slot>
            </div>
            <div v-if="actionItems || $slots.actionItems">
              <slot name="actionItems">
                <ActionIcons :actions="actionItems" />
              </slot>
            </div>
            <div v-if="menuItems || $slots.menuItems">
              <slot name="menuItems">
                <ThreeDotsMenu v-if="menuItems" :items="menuItems" />
              </slot>
            </div>
          </div>
        </slot>
      </div>
    </div>
    <div v-if="show" class="row-content">
      <div class="container">
        <slot name="content">
          <div v-for="(row, index) in rows" v-bind:key="index" class="row">
            <div class="col">{{ row.title }}:</div>
            <div class="col">{{ row.data }}</div>
          </div>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
import ActionIcons from "@/components/display/ActionIcons";
import Icon from "@/components/display/icon/Icon";
import { ref } from "@vue/composition-api";
import ThreeDotsMenu from "@/components/display/ThreeDotsMenu";

export default {
  name: "TableMobileRow",
  props: {
    headerTitle: {
      type: String,
      default: "Title",
    },
    actionItems: Array,
    menuItems: Array,
    rows: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    ActionIcons,
    Icon,
    ThreeDotsMenu,
  },
  setup() {
    const show = ref(false);
    const toggle = () => {
      show.value = !show.value;
    };
    const getExpandCollapseIconRotation = () => (show.value ? 90 : 270);
    return {
      show,
      toggle,
      getExpandCollapseIconRotation,
    };
  },
};
</script>

<style lang="scss" scoped>
.row-header {
  min-height: 3rem;
  border-top-width: 1px;
  border-top-style: solid;
  padding: 0 0.75rem;
}
.row-content {
  border-top-width: 1px;
  border-top-style: solid;
  padding: 1rem;
  font-size: 0.875rem;
  .row {
    min-height: 2.75rem;
    align-items: center;
  }
}
</style>
